import * as Types from '../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddCommentMutationVariables = Types.Exact<{
  organisationId: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
  entitySelector: Types.Scalars['JSON']['input'];
  entityId: Types.Scalars['String']['input'];
  comment: Types.Scalars['String']['input'];
}>;


export type AddCommentMutation = { __typename?: 'Mutation', createWorkbenchComment?: { __typename?: 'CreateWorkbenchCommentPayload', workbenchComment?: { __typename?: 'WorkbenchComment', id: string, value: string } | null } | null };

export type UpdateCommentMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  value: Types.Scalars['String']['input'];
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateWorkbenchComment?: { __typename?: 'UpdateWorkbenchCommentPayload', workbenchComment?: { __typename?: 'WorkbenchComment', id: string, value: string } | null } | null };

export type CommentsForEntityQueryVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  entityId: Types.Scalars['String']['input'];
}>;


export type CommentsForEntityQuery = { __typename?: 'Query', workbenchComments?: { __typename?: 'WorkbenchCommentsConnection', nodes: Array<{ __typename?: 'WorkbenchComment', id: string, value: string, entitySelector?: unknown | null, entityId: string, nodeId: string }> } | null };

export type DeleteCommentMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteWorkbenchComment?: { __typename?: 'DeleteWorkbenchCommentPayload', workbenchComment?: { __typename?: 'WorkbenchComment', id: string } | null } | null };


export const AddCommentDocument = gql`
    mutation addComment($organisationId: String!, $environmentId: String!, $entitySelector: JSON!, $entityId: String!, $comment: String!) {
  createWorkbenchComment(
    input: {workbenchComment: {organisationId: $organisationId, environmentId: $environmentId, entitySelector: $entitySelector, entityId: $entityId, entityType: ACTION_FLOW_CONFIG_VERSION, value: $comment}}
  ) {
    workbenchComment {
      id
      value
    }
  }
}
    `;

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      environmentId: // value for 'environmentId'
 *      entitySelector: // value for 'entitySelector'
 *      entityId: // value for 'entityId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentMutation, AddCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentMutation, AddCommentMutationVariables>(AddCommentDocument, options);
      }
export type AddCommentMutationHookResult = ReturnType<typeof useAddCommentMutation>;
export type AddCommentMutationResult = Apollo.MutationResult<AddCommentMutation>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<AddCommentMutation, AddCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation updateComment($id: String!, $value: String!) {
  updateWorkbenchComment(input: {id: $id, patch: {value: $value}}) {
    workbenchComment {
      id
      value
    }
  }
}
    `;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const CommentsForEntityDocument = gql`
    query commentsForEntity($environmentId: String!, $entityId: String!) {
  workbenchComments(
    condition: {entityType: ACTION_FLOW_CONFIG_VERSION, environmentId: $environmentId, entityId: $entityId}
  ) {
    nodes {
      id
      value
      entitySelector
      entityId
      nodeId
    }
  }
}
    `;

/**
 * __useCommentsForEntityQuery__
 *
 * To run a query within a React component, call `useCommentsForEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsForEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsForEntityQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useCommentsForEntityQuery(baseOptions: Apollo.QueryHookOptions<CommentsForEntityQuery, CommentsForEntityQueryVariables> & ({ variables: CommentsForEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsForEntityQuery, CommentsForEntityQueryVariables>(CommentsForEntityDocument, options);
      }
export function useCommentsForEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsForEntityQuery, CommentsForEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsForEntityQuery, CommentsForEntityQueryVariables>(CommentsForEntityDocument, options);
        }
export function useCommentsForEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommentsForEntityQuery, CommentsForEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommentsForEntityQuery, CommentsForEntityQueryVariables>(CommentsForEntityDocument, options);
        }
export type CommentsForEntityQueryHookResult = ReturnType<typeof useCommentsForEntityQuery>;
export type CommentsForEntityLazyQueryHookResult = ReturnType<typeof useCommentsForEntityLazyQuery>;
export type CommentsForEntitySuspenseQueryHookResult = ReturnType<typeof useCommentsForEntitySuspenseQuery>;
export type CommentsForEntityQueryResult = Apollo.QueryResult<CommentsForEntityQuery, CommentsForEntityQueryVariables>;
export const DeleteCommentDocument = gql`
    mutation deleteComment($id: String!) {
  deleteWorkbenchComment(input: {id: $id}) {
    workbenchComment {
      id
    }
  }
}
    `;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;